// extracted by mini-css-extract-plugin
export default {"content":"content__2QK8M","unitQuantity":"unitQuantity__1wRtx"};
    if(module.hot) {
      // 1764953375390
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  